import ragnarPic from "@/public/images/artists/ragnar.jpg";
import { Artist } from "@/types/types";

export const ragnar = {
  id: "105",
  name: "Ragnar",
  image: ragnarPic,
  description: `Ragnar excels at one thing and one thing only: growling. But when it comes to growls, he does it exceptionally well.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fragnar-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Growl", "Rock"],
      secondary: ["Scream", "Experimental"],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "Mid",
      },
      specific: {
        low: 54,
        high: 68,
      },
    },
  },
} as const satisfies Artist;
